<template>
	<inertia-head title="Administrator" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Administrator</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Setup Member's Password Override
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-md-6">
				<div class="block block-rounded">
					<div class="block-header block-header-default">
						<h3 class="block-title">Enter member's password override</h3>
					</div>
					<form @submit.prevent="submit">
						<div class="block-content">
							<div class="form-floating mb-4">
								<input
									v-model="form.bypass"
									id="bypass"
									type="text"
									class="form-control"
									:class="{ 'is-invalid': form.errors.bypass }"
									placeholder="Enter your bypass"
								/>
								<label class="form-label" for="bypass">Bypass</label>
								<div v-if="form.errors.bypass" class="invalid-feedback">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.bypass }}
								</div>
							</div>
						</div>
						<div
							class="block-content block-content-full block-content-sm bg-body-light text-end"
						>
							<button
								type="submit"
								class="btn btn-alt-primary"
								:disabled="form.processing || !form.isDirty"
							>
								<i class="fa fa-save opacity-50 me-1"></i> Save Changes
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		bypass: String,
		flash: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			bypass: props.bypass,
		})

		const submit = () => {
			form.post(route('post.update-bypass'))
		}

		return {
			form,
			submit,
		}
	},
}
</script>
